import Alert from "../../ui/alert"
import { colors } from "../../../utilities/colors"

export default function AchInitiatedAlert({ auditUnit }) {
  if (!auditUnit?.attributes["ach-initiated"]) {
    return null
  }

  return (
    <Alert title="ACH Initiated" bgColor={colors.yellow} />
  )
}